import React, { Component } from 'react'
import "./PaySuccess.less";
export default class PaySuccess extends Component {
  constructor(props) {
    super(props);
  }
  cancel= () => {
    this.props.cancelDialog('paySuccess');
  }
  render() {
    return (
      <div className='paySuccessDialog'>
        <div className='mask' onClick={this.cancel}></div>
        <div className='content'>
          <label className='ico-moon icon-closes closes_btn' onClick={this.cancel}></label>
          <div className='tips'>
            <img src="https://cdn.jisuapp.cn/static/webapp/images/chatgpt/successlog.png"/>
            <div>&nbsp;&nbsp;购买成功！</div>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/chatgpt-page/component/PaySuccess/PaySuccess.jsx